import { axiosInstance } from './axios';
import { REACT_APP_API_SERVER_URL } from './constants';

export const getCombinedBusinessCodes = async () => {
  const response = await axiosInstance.get(
    `${REACT_APP_API_SERVER_URL}/api/gemicro-code/combined-business`,
  );

  const {
    data: { entityTypes, businessTypes },
  } = response;

  return { entityTypes, businessTypes };
};
